import WebComponent from 'fg-frontend/src/webComponents/WebComponent';


class MailingInbox extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {

		if(window.innerWidth < 768) {
			const url = new URL(window.location.href);
			const messageId = url.searchParams.get('messageId');
			if(messageId) {
				this.element.classList.add('mailing-inbox--mobile');
			}
		}

	}


}


export default MailingInbox;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Mailing/MailingInbox.js